import * as React from "react";
import { ButtonProps, Button, Modal, Input, Label, SemanticCOLORS, StrictModalProps, InputOnChangeData } from "semantic-ui-react";

interface AdditionalProps {
    promptText: string;
    headingText?: string;
    typeToConfirmText?: string;
    confirmText?: string;
    cancelText?: string;
    confirmButtonColor?: SemanticCOLORS;
    modalClassName?: string;
    modalSize?:  StrictModalProps["size"];
    onClick: Exclude<ButtonProps["onClick"], undefined>;
}

interface State {
    open: boolean;
    confirmAttempted: boolean;
    enteredConfirmationText: string;
}

export class ConfirmedButton extends React.Component<ButtonProps & AdditionalProps, State> {
    public state = { open: false, confirmAttempted: false, enteredConfirmationText: "" };

    public render() {
        const {
            onClick,
            promptText,
            headingText,
            typeToConfirmText,
            confirmText,
            cancelText,
            confirmButtonColor,
            modalClassName,
            modalSize,
            ...buttonProps } = this.props;

        const confirm = (event: React.MouseEvent<HTMLButtonElement>, data: ButtonProps) => {
            this.setState({ confirmAttempted: true });
            if (!typeToConfirmText || typeToConfirmText === this.state.enteredConfirmationText) {
                onClick(event, data);
                this.close();
            }
        };

        const onChangeText = (_event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => this.setState({ enteredConfirmationText: data.value });

        return (
            <>
                <Button type="button" {...buttonProps} onClick={this.open} />
                <Modal size={modalSize ?? "mini"} open={this.state.open}>
                    {this.props.headingText ?
                        <Modal.Header>
                            {this.props.headingText}
                        </Modal.Header>
                        : null
                    }
                    <Modal.Content>
                        <div className={modalClassName}>
                            {promptText}
                        </div>
                        {typeToConfirmText ?
                            <Input fluid onChange={onChangeText} /> : null}
                        {typeToConfirmText && this.state.confirmAttempted && typeToConfirmText !== this.state.enteredConfirmationText ?
                            <Label basic color="red" pointing>Entered text does not match "{typeToConfirmText}"</Label> : null}
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={this.close}>{cancelText || "Cancel"}</Button>
                        <Button negative={confirmButtonColor ? false : true} onClick={confirm} color={confirmButtonColor}>{confirmText || "Confirm"}</Button>
                    </Modal.Actions>
                </Modal>
            </>
        );
    }

    private open = () => this.setState({ open: true, confirmAttempted: false, enteredConfirmationText: "" });
    private close = () => this.setState({ open: false, confirmAttempted: false, enteredConfirmationText: "" });
}
